import { StyleSheet } from 'react-native';
import { PALETTE } from '../../../../../constants';

export default StyleSheet.create({
  root: {
    flexDirection: 'row',
    paddingBottom: 3,
  },
  description: {
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  header: {
    color: 'white'
  },
  headerDisabled: {
    color: PALETTE.primaryTextDisabled,
  },
  subDescription: {
    color: PALETTE.secondaryText,
  },
  value: {
    flex: 1,
    alignItems: 'flex-end',
    paddingTop: 1,
    marginRight: 12,
  },
});
